import config from "../../config";
import { applyDefaultAnalyticsUrlRedaction } from "./analyticsUrlRedactionConfig";

export { RESET_PASSWORD_EXECUTE_PATH_REGEX } from "./analyticsUrlRedactionConfig";

export const SANITIZE_ANALYTICS_URL_FAILED = "sanitize-failed";

function getAnalyticsUrlBaseOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  if (!config.webAppUrl) {
    return null;
  }

  try {
    return new URL(config.webAppUrl).origin;
  } catch {
    return null;
  }
}

export default function sanitizeAnalyticsUrl(href) {
  if (!href || typeof href !== "string") {
    return href;
  }

  let parsed;

  try {
    const baseOrigin = getAnalyticsUrlBaseOrigin();

    if (!baseOrigin) {
      return SANITIZE_ANALYTICS_URL_FAILED;
    }

    parsed = new URL(href, baseOrigin);
  } catch {
    return SANITIZE_ANALYTICS_URL_FAILED;
  }

  const { pathname, search } = applyDefaultAnalyticsUrlRedaction(parsed);

  return `${parsed.origin}${pathname}${search}`;
}

export function sanitizeAnalyticsPathValue(pathValue) {
  if (!pathValue || typeof pathValue !== "string") {
    return pathValue;
  }

  try {
    const baseOrigin = getAnalyticsUrlBaseOrigin();

    if (!baseOrigin) {
      return SANITIZE_ANALYTICS_URL_FAILED;
    }

    const parsed = new URL(pathValue, baseOrigin);
    const { pathname, search } = applyDefaultAnalyticsUrlRedaction(parsed);

    return `${pathname}${search}`;
  } catch {
    return SANITIZE_ANALYTICS_URL_FAILED;
  }
}

function isAbsoluteAnalyticsUrl(value) {
  return /^https?:\/\//i.test(value);
}

export function sanitizeAnalyticsEventPropertyValue(value) {
  if (typeof value !== "string") {
    return value;
  }

  if (isAbsoluteAnalyticsUrl(value)) {
    return sanitizeAnalyticsUrl(value);
  }

  if (value.startsWith("/")) {
    return sanitizeAnalyticsPathValue(value);
  }

  return value;
}
